import {
  PBPListResponse,
  PBPGetResponse,
  type PBPPermissionsExpansion,
  type PBPExpandedResponse,
  type PBPExpandedListResponse
} from '@percent/admin-dashboard/services/pbpResponses'
import {
  GroupServiceCapabilities,
  GetGroupsProps,
  Group,
  CreateGroupProps,
  GetGroupByIdProps,
  GetGroupMembersProps,
  GroupMember,
  EditGroupProps,
  AddMembersProps,
  RemoveGroupMemberProps,
  ChangeGroupMemberRoleProps,
  type GroupPermission
} from './groups.types'
import { throttleAsync } from '@percent/utility'

export const groupService = ({ percentClient }: GroupServiceCapabilities) => ({
  getGroups: throttleAsync(
    (params: GetGroupsProps) =>
      percentClient.get<PBPExpandedListResponse<Group, PBPPermissionsExpansion<GroupPermission>>>('/v1/groups', {
        params: { ...params, expand: 'permissions' }
      }),
    1000,
    { leading: true, trailing: true }
  ),
  // For pickers: skips the per-group permissions expansion, which makes getGroups slow to search
  searchGroups: throttleAsync(
    (params: GetGroupsProps) => percentClient.get<PBPListResponse<Group>>('/v1/groups', { params }),
    1000,
    { leading: true, trailing: true }
  ),
  getGroupById: ({ id }: GetGroupByIdProps) =>
    percentClient.get<PBPExpandedResponse<Group, PBPPermissionsExpansion<GroupPermission>>>(`/v1/groups/${id}`, {
      params: { expand: 'permissions' }
    }),
  getGroupMembers: throttleAsync(
    ({ groupId, ...params }: GetGroupMembersProps) =>
      percentClient.get<PBPListResponse<GroupMember>>(`/v1/groups/${groupId}/members`, { params }),
    1000,
    { leading: true, trailing: true }
  ),
  createGroup: (payload: CreateGroupProps) => percentClient.post('/v1/groups', payload),
  editGroup: ({ id, ...payload }: EditGroupProps) =>
    percentClient.patch<PBPGetResponse<Group>>(`/v1/groups/${id}`, payload),
  deleteGroup: ({ id }: { id: string }) => percentClient.delete(`/v1/groups/${id}`),
  addMembers: ({ groupId, ...payload }: AddMembersProps) =>
    percentClient.post(`/v1/groups/${groupId}/members`, payload),
  removeGroupMember: ({ groupId, memberId }: RemoveGroupMemberProps) =>
    percentClient.delete(`/v1/groups/${groupId}/members/${memberId}`),
  changeGroupMemberRole: ({ groupId, memberId, role }: ChangeGroupMemberRoleProps) =>
    percentClient.put(`/v1/groups/${groupId}/members/${memberId}`, { role })
})
